module.exports = __webpack_public_path__ + "static/media/卡券.4ba93730.png";